import { request } from "./request";
import * as apiConstants from "../constants/Api";

export const fetchBranding = () => {
  return request("get", `${apiConstants.SERVER_URL}/api/v1/branding.json`);
};

export const postHelpRequest = ({ body }) => {
  return request(
    "post",
    `${apiConstants.SERVER_URL}/api/v3/send_help_email`,
    body
  );
};
